import { makeSerial, GUID, timeout } from 'core/utils';
import Track from 'src/paraphraser/handlers/track';
import { postFreezeWords, getParaphrase } from 'src/paraphraser/handlers/api';
import { getSingleFlip } from 'src/paraphraser/handlers/api';
import Wrapper from './wrapper';
import Output from './output';
import WaltCache from './walt_cache';
import Stats from './Stats';
import { splitIntoSentences } from 'core/utils/sentenceSplitter';
import CONSTANTS, { QUILL_SETTINGS } from '../constants';
import logger from 'core/logger/logger';
import { getReduxStore } from 'src/_common/redux/store';
import ParaModel from './ParaModel';
import Bugsnag from '@bugsnag/js';
import { setOutputParaphraserUpdater, setCompareModeUpdater } from '../actions/paraModelActions';
import IndexDbStore from 'core/utils/indexedDbClient';
import { getTimeDifference } from 'src/_common/handlers/helper';
import { IndexedDb, modeSequenceMap } from 'config/constants';
const dispatch = action => getReduxStore()?.dispatch(action);
class Paraphraser {
  constructor(text, pathI, indent, submissionID, isMulti, quoteIndex) {
    if (text) {
      text = text.trim();
    }
    if (text == null) {
      this.loading = false;
      return;
    }
    this.quoteIndex = quoteIndex;
    this.singleFlipCallStatus = true;
    this.singleParaCallStatus = true;
    this.text = text;
    this.pID = GUID();
    if (this.text?.length)
      Track.createdParaphraser(this.pID, this.text, submissionID, ParaModel.inputLanguage);
    this.submissionID = submissionID;
    this.origText = text;
    this.locked = false;
    this.lastRenderedText = text;
    this.setFocusedOutput(new Output(text, this, null, true, 0));
    this.outputs = [this.focusedOutput];
    this.completed = false;
    this.pathI = pathI === undefined ? 0 : pathI;
    this.lastPathID = -1;
    this.attempts = 0;
    this.lastParaphrase = null;
    this.reciepts = [];
    this.isRepeat = false;
    this.loading = true;
    this.indent = indent;
    this.wasEdited = false;
    this.draftName = 'unknown';
    this.clearBeams('para init');
    this.strength = -1;
    this.focusTimeStart = 0;
    //this.focusTimer = null;
    this.focusTime = 0;
    this.changed = false;
    this.isMulti = isMulti;
    this.fthresh = QUILL_SETTINGS.fthresh;
    this.modelId = '';
    this.activeBeamsForEachMode = {};
    this.postCitation = '';

    this.compareSelectedAndChange = false;
    this.compareModeEdited = {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      6: false,
      7: false,
      8: false,
      9: false,
      10: false,
    };
    this.singleParaphraseModelData = {
      0: {},
      1: {},
      2: {},
      3: {},
      4: {},
      6: {},
      7: {},
      8: {},
      9: {},
      10: {},
    };
    this.frozenWords = [];
    this.index = undefined;
  }

  startFocusTimer() {
    // this.focusTimer = setInterval(() => {
    //   this.focusTime += 0.1;
    // }, 100);
    this.focusTimeStart = Date.now();
  }

  stopFocusTimer() {
    // clearInterval(this.focusTimer);
    // this.focusTimer = null;
    this.focusTime += getTimeDifference(this.focusTimeStart);
    this.focusTimeStart = 0;
  }

  loadExport(para) {
    var self_serializable = ['outputs'];
    Object.keys(para).forEach(prop => {
      if (self_serializable.includes(prop)) return;
      this[prop] = para[prop];
    });
    this.outputs = para.outputs.map(o => {
      var otemplate = new Output(null);
      otemplate.loadExport(o, this);
      return otemplate;
    });
    this.setFocusedOutput(this.outputs[this.focusedOutput]);
  }
  /**
   * Self_serializable is the array of keys which contains circulare dependency
   * @param para = is the paraphraser object from which we are taking the key value pairs
   */
  saveHistoryData(para) {
    var self_serializable = ['outputs', 'focusedOutput'];
    Object.keys(para).forEach(prop => {
      if (self_serializable.includes(prop)) return;
      this[prop] = para[prop];
    });

    /* We are doing the same process on output level
        to remove the circular dependency and create new output
        We are taking only one output object for local storage for each paraphraser
        Created Array with that single object and also make that object focusedfor that 
        Paraphraser  */

    var otemplate = new Output(null);
    otemplate.loadExport(para.focusedOutput, this);
    let historyOutputs = otemplate;

    this.outputs = [historyOutputs];
    this.focusedOutput = historyOutputs;
  }

  serialize() {
    var serial = makeSerial(this, ['checkPoints', 'reciepts']);
    serial.focusedOutput = this.outputs.indexOf(this.focusedOutput);
    return serial;
  }

  /* changeText(text, submissionID) {
    this.changed = true;
    this.text = text;
    this.origText = text;
    this.pathI = 0;
    this.pID = GUID();
    this.focusTime = 0;
    this.setFocusedOutput(new Output(text, this, null, true));
    this.outputs = [this.focusedOutput];
    Track.changedParaphraserText(this.pID, this.text, submissionID);
    this.submissionID = submissionID;
  } */

  /* promiseParaphrase(update, strength) {
    this.strength = strength;
    return new Promise((res, rej) => {
      this.paraphrase(
        {
          finished: () => {
            update();
            res(this);
          },
        },
        strength
      );
    });
  } */

  setFocusedOutput(output) {
    if (this.focusedOutput && this.focusedOutput.stopFocusTimer) {
      this.focusedOutput.stopFocusTimer();
    }
    this.focusedOutput = output;
    if (this.focusedOutput && this.focusedOutput.startFocusTimer) {
      this.focusedOutput.startFocusTimer();
    }

    this.getSentenceReportDB(this.origText).then(res => {
      if (res && res?.includes(this.focusedOutput?.getOutputString())) {
        this.focusedOutput.reported = true;
      } else {
        this.focusedOutput.reported = false;
      }
    });

    // dispatch(
    //   setOutputParaphraserUpdater({
    //     pID: this.pID,
    //   })
    // );
    // setTimeout(() => {
    ParaModel.batchDispatchCall(dispatch, this.pID);
    // }, 0);
  }

  getSentenceReportDB = async orig => {
    return IndexDbStore.getInstance().getFromIndexedDB(
      orig,
      IndexedDb.collections.reportedSentences
    );
  };

  onLastOutput() {
    return this.focusedOutput === this.outputs[this.outputs.length - 1];
  }

  onFirstOutput() {
    return this.focusedOutput === this.outputs[0];
  }

  edited() {
    ParaModel.saveParaphraserData();
    this.wasEdited = true;
    // Stats.updateStats();
  }

  prevOutput(cb) {
    var i = this.outputs.indexOf(this.focusedOutput);
    if (i - 1 === 0)
      this.outputs[i - 1].setText(this.origText, () => {
        ParaModel.batchDispatchCall(dispatch, this.pID);
      });
    if (i > 0) {
      this.setFocusedOutput(this.outputs[i - 1]);
    }
    this.edited();
    if (cb)
      cb(
        i - 1,
        this.focusedOutput?.strength,
        this.outputs[i]?.strength,
        this.focusedOutput?.fthresh,
        this.outputs[i]?.fthresh
      );
  }

  nextOutput(cb) {
    var i = this.outputs.indexOf(this.focusedOutput);
    if (i < this.outputs.length) {
      this.setFocusedOutput(this.outputs[i + 1]);
    }
    this.edited();
    if (cb) cb();
  }

  redoWF(callbacks, articleStrength, articleFthresh) {
    if (this.locked) {
      QUILL_SETTINGS.fthresh = this.focusedOutput.fthresh;
      callbacks.finished();
      return;
    }
    let strength = this.focusedOutput.strength;
    let currentFthresh = this.focusedOutput.fthresh;
    if (articleFthresh == currentFthresh) {
      ParaModel.batchDispatchCall(dispatch, this.pID);
      callbacks.finished();
      return;
    }
    let activebeam = this.activeBeamsForEachMode[strength];
    /*  if (!beams) return;
    let activebeam = beams[0]; */

    // handle the case when single paraphrase api failed
    if (!activebeam && activebeam !== '') activebeam = this.origText;

    this.loading = true;
    this.loading_WF = true;
    // dispatch(setOutputParaphraserUpdater([this.pID]));
    ParaModel.batchDispatchCall(dispatch, this.pID);
    this.addOutput(
      activebeam,
      () => {
        callbacks.finished(this.focusedOutput.getOutputString());
        this.edited();
      },
      strength,
      articleFthresh
    );
  }

  compareModeOriginalSentence() {
    // const output = new Output(this.text, this, null, true);
    // this.outputs.push(output);
    // this.setFocusedOutput(output);
    // this.strength = output.strength;
    // this.edited();
    this.outputs[0].setText(this.origText, () => {
      ParaModel.batchDispatchCall(dispatch, this.pID);
    });
    this.setFocusedOutput(this.outputs[0]);
    this.strength = this.outputs[0].strength;
    this.edited();
    // ParaModel.update('Updated The strength');
  }

  onLastOutputCompareModeWise(strength) {
    let outputsLength = this.outputs.length - 1;
    let compareModeoutputArrayLength =
      this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray.length;

    return (
      this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength ===
      this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray[
        compareModeoutputArrayLength - 1
      ]
    );
  }

  compareModeOn() {
    let outputsArrayLength = this.outputs.length;

    var callbacks = () => {
      // Stats.updateStats();
    };
    modeSequenceMap.forEach(i => {
      if (
        !this.outputs[outputsArrayLength - 1]?.compareModeOutputs[i]?.modeStrengthArray.length &&
        i !== this.strength
      )
        this.paraphrase(callbacks, i, true);
      else if (i === this.strength) {
        if (
          this.outputs[this.outputs.length - 1] ===
          this.outputs[this.outputs.length - 1].compareModeOutputs[i].focusedComparemodeStrength
        )
          return;

        this.outputs[this.outputs.length - 1]?.compareModeOutputs[i]?.modeStrengthArray.push(
          this.outputs[this.outputs.length - 1]
        );

        this.outputs[this.outputs.length - 1].compareModeOutputs[i].focusedComparemodeStrength =
          this.outputs[this.outputs.length - 1];
      }
    });
  }

  compareModeOnNonPremium() {
    let outputsArrayLength = this.outputs.length;

    var callbacks = () => {
      // Stats.updateStats();
    };
    [2].forEach(i => {
      if (
        !this.outputs[outputsArrayLength - 1]?.compareModeOutputs[i]?.modeStrengthArray.length &&
        i !== this.strength
      )
        this.paraphrase(callbacks, i, true);
      else if (i === this.strength) {
        this.outputs[this.outputs.length - 1]?.compareModeOutputs[i]?.modeStrengthArray.push(
          this.outputs[this.outputs.length - 1]
        );

        this.outputs[this.outputs.length - 1].compareModeOutputs[i].focusedComparemodeStrength =
          this.outputs[this.outputs.length - 1];
      }
    });
  }

  pushCompareModeOutput(strength) {
    let outputCompareMode =
      this.outputs[this.outputs.length - 1]?.compareModeOutputs[strength]
        ?.focusedComparemodeStrength;
    this.outputs.push(outputCompareMode);
    this.outputs[this.outputs.length - 1].compareModeOutputs =
      this.outputs[this.outputs.length - 2]?.compareModeOutputs;
    this.setFocusedOutput(outputCompareMode);
    this.strength = strength;
    this.fthresh = outputCompareMode.fthresh;
    this.edited();
    // ParaModel.update('Updated The strength');
  }

  compareModeRedo(callbacks, strength, fthresh) {
    // if (this.locked) {
    //   callbacks.finished();
    //   return;
    // }
    // this.strength = strength;

    // let outputsLength = this.outputs.length-1;

    // var beams = this.outputs[outputsLength].compareModeOutputs[strength].focusedComparemodeStrength.beams[strength];

    var beams = this.beams[strength];

    if (strength === undefined) {
      strength = 0;
      this.clearBeams('str undefined');
    }

    if (beams === undefined) {
      this.clearBeams('beams undef');
      beams = this.beams[0];
      strength = 0;
    }

    if (beams.length > 0) {
      // this.loading = true;
      // this.loading_MODES = true;

      // if (this.focusedOutput.strength != strength && this.activeBeamsForEachMode[strength])
      //   var newBeam = this.activeBeamsForEachMode[strength];
      // else {
      var newBeam = beams.shift();
      this.activeBeamsForEachMode[strength] = newBeam;
      // }
      this.addOutput(
        newBeam,
        () => {
          callbacks.finished(this.focusedOutput.getOutputString());
          this.edited();
        },
        strength,
        fthresh,
        true
      );
    } else {
      this.text = this.origText;
      this.attempts = 0;
      this.paraphrase(callbacks, strength, true);
    }
    // setTimeout(() => {

    // }, 1000);
    //  Track.redoParaphrase(this.pID);
  }

  compareModeNextOutput(strength, cb) {
    let outputsLength = this.outputs.length - 1;
    let compareModeoutputArrayLength =
      this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray.length;

    let focusedCompareOutput =
      this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength;

    let i =
      this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray.indexOf(
        focusedCompareOutput
      );

    if (
      compareModeoutputArrayLength - 1 - i > 0 &&
      this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray[i] ===
        this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray[i + 1]
    )
      i = i + 1;

    if (i < compareModeoutputArrayLength - 1) {
      this.outputs[outputsLength].compareModeOutputs[strength].focusedComparemodeStrength =
        this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray[i + 1];
      if (strength === this.strength) {
        // this.offCompareMode();
        this.outputs.push(
          this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength
        );
        if (this.outputs.length >= 3)
          this.outputs[this.outputs.length - 1].compareModeOutputs =
            this.outputs[this.outputs.length - 2]?.compareModeOutputs;
        this.setFocusedOutput(
          this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength
        );
        this.edited();
        // ParaModel.update('Updated The strength');
      }
    }
    // this.edited();
    if (cb) cb();
  }

  compareModePrevOutput(strength, cb) {
    let outputsLength = this.outputs.length - 1;
    // let compareModeoutputArrayLength = this.outputs[outputsLength].compareModeOutputs[strength]
    //   .modeStrengthArray.length;

    let focusedCompareOutput =
      this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength;

    let i =
      this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray.indexOf(
        focusedCompareOutput
      );
    if (i > 0) {
      this.outputs[outputsLength].compareModeOutputs[strength].focusedComparemodeStrength =
        this.outputs[outputsLength].compareModeOutputs[strength]?.modeStrengthArray[i - 1];
      if (strength === this.strength) {
        // this.offCompareMode();
        this.outputs.push(
          this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength
        );
        if (this.outputs.length >= 3 && this.outputs[this.outputs.length - 1]?.compareModeOutputs)
          this.outputs[this.outputs.length - 1].compareModeOutputs =
            this.outputs[this.outputs.length - 2]?.compareModeOutputs;
        this.setFocusedOutput(
          this.outputs[outputsLength].compareModeOutputs[strength]?.focusedComparemodeStrength
        );
        this.edited();
        // ParaModel.update('Updated The strength');
      }
    }
    //  this.edited();
    if (cb) cb();
  }

  compareModeDeleteAlloutputs() {
    [0, 1, 2, 3, 4].forEach(str => {
      this.outputs[this.outputs.length - 1].compareModeOutputs[str].modeStrengthArray = [];
      this.outputs[this.outputs.length - 1].compareModeOutputs[str].focusedComparemodeStrength = {};
    });
  }

  comapreModeRedoWf(callbacks, fthresh, strength) {
    let activebeam = this.activeBeamsForEachMode[strength];
    /*  if (!beams) return;
    let activebeam = beams[0]; */

    // handle the case when single paraphrase api failed
    if (!activebeam && activebeam !== '') activebeam = this.origText;

    this.addOutput(
      activebeam,
      () => {
        callbacks.finished(this.focusedOutput.getOutputString());
        this.edited();
      },
      strength,
      fthresh,
      true
    );
  }

  redo(callbacks, strength, fthresh, forced = false) {
    if (this.locked) {
      callbacks.finished();
      return;
    }
    this.strength = strength;
    var beams = this.beams[strength];

    if (strength === undefined) {
      strength = 0;
      this.clearBeams('str undefined');
    }

    if (beams === undefined) {
      this.clearBeams('beams undef');
      beams = this.beams[0];
      strength = 0;
    }

    if (beams.length > 0) {
      this.loading = true;
      this.loading_MODES = true;
      // dispatch(setOutputParaphraserUpdater([this.pID]));
      ParaModel.batchDispatchCall(dispatch, this.pID);
      if (
        (this.focusedOutput.strength != strength || forced) &&
        this.activeBeamsForEachMode[strength]
      )
        var newBeam = this.activeBeamsForEachMode[strength];
      else {
        var newBeam = beams.shift();
        this.activeBeamsForEachMode[strength] = newBeam;
      }
      this.addOutput(
        newBeam,
        () => {
          callbacks.finished(this.focusedOutput.getOutputString());
          this.edited();
        },
        strength,
        fthresh
      );
    } else {
      this.text = this.origText;
      this.attempts = 0;
      this.paraphrase(callbacks, strength);
    }
    Track.redoParaphrase(this.pID);
  }

  dpara(text, cb, callbacks, strength) {
    var promises = [];
    promises.push(timeout(60000));
    promises.push(
      new Promise((res, rej) => {
        if (!strength) {
          strength = 0;
        }
        var beams = this.beams[strength];
        if (beams === undefined) {
          this.clearBeams('beams undef');
          beams = this.beams[0];
          console.log(strength);
          strength = 0;
        }
        if (beams.length === 0) {
          var startTime = Date.now();

          // Now, we are returning a promise from below function. The promise will return reject in case single-para fails.
          // Hence, the catch is added.
          this.freedom(
            { text: text, strength: strength },
            out => {
              var reqTime = Date.now() - startTime;
              try {
                if (out.error) {
                  callbacks.panic({ reason: 'no beams', text: text });
                  this.pMethod = 'errored';
                } else {
                  callbacks.unpanic();
                  this.pMethod = 'strength: ' + strength;
                }
                /* if (window.location.pathname === '/app') {
                  window.history.pushState(
                    {},
                    'QuillBot - Free Paraphrasing Tool | AI Rewriter',
                    '/' + window.location.search
                  );
                } */
                Track.recordBeams(
                  this.pID,
                  strength,
                  this.beams[strength],
                  text,
                  reqTime,
                  out.runTimes,
                  ParaModel.inputLanguage
                );
                this.activeBeamsForEachMode[strength] = this.beams[strength][0];
                if (!this.singleParaphraseModelData[strength].eventSent) {
                  Track.submittedSentence(
                    strength,
                    text,
                    this.singleParaphraseModelData[strength].modelId,
                    getReduxStore()?.getState()?.common?.isOpencompareModeDrawer,
                    ParaModel.inputLanguage
                  );
                  this.singleParaphraseModelData[strength].eventSent = true;
                }
                res({ text: this.beams[strength].shift() });
              } catch (e) {
                callbacks.panic({ reason: 'unknown', text: text });
                res({ text: text });
              }
            },
            err => {
              this.singleParaCallStatus = false;
              callbacks.panic({ reason: 'api error', text: text });
              this.pMethod = 'errored';
              res({ text: text });
            }
          ).catch(error => {
            logger('PPHR API FAILED', 'SINGLE-PARA-API-FAILED');
            res({ text: text });
          });
          this.pathI += 1;
          this.attempts += 1;
        } else {
          this.activeBeamsForEachMode[strength] = beams[0];
          if (this.singleParaphraseModelData)
            if (!this.singleParaphraseModelData[strength]?.eventSent) {
              Track.submittedSentence(
                strength,
                text,
                this.singleParaphraseModelData[strength].modelId,
                getReduxStore()?.getState()?.common?.isOpencompareModeDrawer,
                ParaModel.inputLanguage
              );
              this.singleParaphraseModelData[strength].eventSent = true;
            }
          res({ text: beams.shift() });
        }
      })
    );

    Promise.race(promises).then(val => {
      if (val === 'TIMEOUT') {
        //this.dpara(text, cb, callbacks)
        callbacks.panic({ reason: 'timeout', text: text });
        cb({ text: text });
      } else {
        cb(val);
      }
    });
  }

  paraphrase(callbacks, strength, isCompareCall = false) {
    if (!isCompareCall) {
      this.strength = strength;
      this.loading = true;
      this.loading_WF = true;
      this.loading_MODES = true;
      // dispatch(
      //   setOutputParaphraserUpdater({
      //     pID: this.pID,
      //   })
      // );
      // ParaModel.timerStart = 0;
      // setTimeout(() => {
      ParaModel.batchDispatchCall(dispatch, this.pID);
      // }, 0);
    }
    if (callbacks.init === undefined) callbacks.init = () => {};
    if (callbacks.finished === undefined) callbacks.finished = () => {};
    if (callbacks.panic === undefined)
      callbacks.panic = reason => {
        Track.triggerPanic(reason, 'undefined');
      };
    if (callbacks.unpanic === undefined) callbacks.unpanic = () => {};
    if (callbacks.gotSegs === undefined) callbacks.gotSegs = () => {};

    var cb = () => {
      this.completed = true;
      // this.loading = false;
      if (callbacks && callbacks.finished && this.focusedOutput) {
        callbacks.finished(this.focusedOutput.getOutputString());
      }
    };

    // THIS IS A HACK
    var text = this.text.replace(/%/g, ' percent ');

    var finalCb = res => {
      callbacks.gotSegs(res);
      cb();
    };

    var fin = flipped => {
      //It will take the fthresh from the local storage if user Interacted or the default value if not.
      // let b = ParaModel.getDefaultFthresh(strength);
      let b = getReduxStore()?.getState()?.pphr?.wordFlipperValue;
      this.addOutput(flipped, finalCb, strength, b, isCompareCall);
      // this.addOutput(flipped, callbacks.gotSegs, strength);
      // cb();
    };
    let numberOfWords = text.split(' ');
    if (text.length < 3 || numberOfWords.length === 1) {
      console.log('short circuting..', text);
      fin(text);
      return;
    }

    callbacks.init();
    this.dpara(
      text,
      paraphrase => {
        fin(paraphrase.text);
      },
      callbacks,
      strength
    );
  }

  getOutputString(index) {
    if (this.outputs == null) return null;
    return this.focusedOutput.getOutputString();
  }

  clearBeams(reason) {
    //console.log("clearing beams: "+reason)
    this.beams = {
      0: [],
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      7: [],
      8: [],
      9: [],
      10: [],
    };
  }

  makeFlips(text, cb, fthresh, isCompareCall, strength) {
    let ft =
      fthresh !== null && fthresh !== undefined
        ? fthresh
        : QUILL_SETTINGS.hasUserInteractedWithWF
        ? this.fthresh
        : QUILL_SETTINGS.fthresh;
    // if (ft === undefined) ft = QUILL_SETTINGS.fthresh;
    if (!isCompareCall) this.fthresh = ft;
    if (text.length > 300 || CONSTANTS.noFlipperApplyModes.includes(strength)) {
      cb();
      return;
    }
    var singleIt = (t, o, itter) => {
      return new Promise((res, rej) => {
        var empty = {
          alt: t,
          walts: {},
          flips: [],
          itter: itter,
        };

        var timeout = setTimeout(() => {
          logger('PPHR Timeout', 'TIMED OUT ON FLIP!');
          res(empty);
        }, 10000);

        var fconvert = -1;
        if (ft === 1) {
          fconvert = 9;
        } else if (ft === 2) {
          fconvert = 7;
        } else if (ft === 3) {
          fconvert = 4;
        }
        if (ft === 0) {
          res(empty);
        }
        try {
          if (o.length > 400) {
            o = '';
          }
        } catch (err) {
          o = '';
        }

        // Don't remove. Code when Flipper backend code is updated.
        if (WaltCache.flips[text] !== undefined) {
          clearTimeout(timeout);
          res();
          return true;
        }

        // Patch to support when the Synonyms code is updated in the back end but not in front end.
        const filterFlipData = flips => {
          return flips.filter(flip => {
            if ([4, 7, 9].indexOf(flip[2]) == -1) {
              return true;
            } else {
              return flip[2] >= fconvert;
            }
          });
        };

        getSingleFlip({
          text: o,
          alt: t,
          fthresh: 9,
        })
          .then(data => {
            this.singleFlipCallStatus = true;
            if (data.flips.length > 0) {
              // WaltCache.record_flips(ft + '~' + t, filterFlipData(data.flips));
              // Don't remove. Code to use when the word flppper upgrade is deployed.
              WaltCache.record_flips(t, data.flips);
            }
            // WaltCache.set(ft + '~' + t, data.walts);
            // Dont Remove
            WaltCache.set(t, data.walts);
            data.itter = itter;
            clearTimeout(timeout);
            res(data);
          })
          .catch(err => {
            res(empty);
            this.singleFlipCallStatus = false;
          });
      });
    };
    // if isMulti then check if multiple sentences. if Not skip, if so then split and combine
    // @TODO: Multi is not being called, should be removed
    if (this.isMulti) {
      // console.log('triggered');
      let sentences = splitIntoSentences(text)
        .filter(s => s.type === 'Sentence')
        .map(s => s.raw);
      var orig_sentences = splitIntoSentences(this.origText)
        .filter(s => s.type === 'Sentence')
        .map(s => s.raw);
      if (sentences.length === 1) {
        singleIt(text, this.origText, 0).then(data => cb(data?.MODEL_ID));
      } else {
        console.log('splitting flips: ', text);
        var new_flips = [];
        var new_walts = {};

        var promises = [];
        for (var i = 0; i < sentences.length; i++) {
          var s = sentences[i];
          var o = '';
          // below code will always throw error, commeting for error handling
          /* if (orig_sentences.length < i) {
            o = orig_sentences[i]
          } */
          promises.push(singleIt(s, o, i));
        }

        var maxes = {};
        Promise.all(promises).then(arr => {
          console.log(arr);
          arr.sort((a, b) => {
            return a.itter - b.itter;
          });
          arr.forEach(d => {
            var new_maxes = {};
            var lwalts = d['walts'];
            var lflips = d['flips'];
            var lwords = Object.keys(lwalts).map(x => x.split('~')[0]);
            lwords.forEach(w => {
              if (maxes[w] === undefined) {
                maxes[w] = 0;
              }
            });

            Object.keys(lwalts).forEach(k => {
              var items = k.split('~');
              var w = items[0];

              var pos = parseInt(items[1]);
              //console.log(items, maxes[w], pos, pos + maxes[w])
              var new_pos = pos + maxes[w];
              var new_key = w + '~' + new_pos;
              new_walts[new_key] = lwalts[k];
              lflips.forEach(f => {
                if (f[0] === k) {
                  f[0] = new_key;
                }
              });

              if (new_maxes[w] === undefined) {
                new_maxes[w] = 0;
              }
              new_maxes[w] = Math.max(new_maxes[w], new_pos);
            });
            maxes = new_maxes;
            new_flips = new_flips.concat(lflips);
          });
          console.log('new_walts', new_walts);
          console.log('new_flips', new_flips);
          WaltCache.record_flips(ft + '~' + text, new_flips);
          WaltCache.set(ft + '~' + text, new_walts);
          cb();
        });
      }
    } else {
      //console.log("make flip: ", text)
      if (ft === 0 || ParaModel.inputLanguage === 'es') {
        cb();
      } else {
        singleIt(text, this.origText, 0).then(data => cb(data?.MODEL_ID));
      }
    }
  }

  addOutput(text, cb, strength, fthresh, isCompareCall) {
    if (text == null) return;
    if (this.outputs == null) this.outputs = [];
    this.lastParaphrase = text;
    this.makeFlips(
      text,
      flipperModelId => {
        var output = new Output(
          text,
          this,
          res => {
            this.lastParaphrase = output.getOutputString();
            if (!isCompareCall) {
              // setTimeout(Stats.updateStats, 500);

              setTimeout(() => {
                this.loading = false;
                this.loading_WF = false;
                this.loading_MODES = false;
                // dispatch(
                //   setOutputParaphraserUpdater({
                //     pID: this.pID,
                //   })
                // );
                ParaModel.batchDispatchCall(dispatch, this.pID);
                this.lastRenderedText = output.getOutputString();
                cb(res);
              }, 0);
            } else {
              setTimeout(() => {
                // dispatch(
                //   setOutputParaphraserUpdater({
                //     pID: this.pID,
                //   })
                // );
                ParaModel.batchDispatchCall(dispatch, this.pID);
                dispatch(setCompareModeUpdater());
                if (cb) cb(res);
              }, 0);
            }
          },
          isCompareCall,
          this.outputs.length,
          { strength, fthresh },
          this.postCitation,
          flipperModelId
        );
        output.origOut = false;
        if (!isCompareCall) {
          this.outputs.push(output);
          if (this.outputs.length >= 3)
            this.outputs[this.outputs.length - 1].compareModeOutputs =
              this.outputs[this.outputs.length - 2]?.compareModeOutputs;
          this.setFocusedOutput(output);
          this.outputs[this.outputs.length - 1]?.compareModeOutputs[
            this.strength
          ]?.modeStrengthArray.push(output);
          if (this.strength)
            this.outputs[this.outputs.length - 1].compareModeOutputs[
              this.strength
            ].focusedComparemodeStrength = output;
        } else {
          output.strength = strength;
          output.fthresh = fthresh;
          this.outputs[this.outputs.length - 1]?.compareModeOutputs[
            strength
          ]?.modeStrengthArray.push(output);
          this.outputs[this.outputs.length - 1].compareModeOutputs[
            strength
          ].focusedComparemodeStrength = output;

          if (this.strength === strength) {
            this.outputs.push(output);
            if (this.outputs.length >= 3)
              this.outputs[this.outputs.length - 1].compareModeOutputs =
                this.outputs[this.outputs.length - 2]?.compareModeOutputs;
            this.setFocusedOutput(output);
            this.fthresh = fthresh;
          }
        }
        return output;
      },
      fthresh,
      isCompareCall,
      strength
    );
  }

  clearSegPrompts() {
    if (this.outputs == null) return;
    this.outputs.forEach(output => {
      output.clearSegPrompts();
    });
  }

  actionAfterParaphrase = (paraphrasedResult, text, cb) => {
    let paras;
    let outs = paraphrasedResult[0];
    for (let i = 0; i < 11; i++) {
      if (outs['paras_' + (i + 1)]) {
        this.singleParaphraseModelData[i]['modelId'] = outs['MODEL_ID'];

        // this.beams[i] = Wrapper.beamMiddleware(
        //   outs['paras_' + (i + 1)].map(e => e.alt),
        //   text
        // );
        let newBeams = new Set([
          ...this.beams[i],
          ...Wrapper.beamMiddleware(
            outs['paras_' + (i + 1)].map(e => e.alt),
            text
          ),
        ]);
        this.beams[i] = Array.from(newBeams);
      }
    }
    if (cb)
      cb({
        interMethod: 'E',
        postMethod: 'Z',
        beams: paras,
        runTimes: outs['run_times'],
      });
  };

  freedom = (options, cb, error) => {
    var text = options.text;
    options['autoflip'] = false; // Globals.autoflip;
    options['wikify'] = false; //Globals.wikify;
    options['fthresh'] = -1; //QUILL_SETTINGS.fthresh;
    let paraphraseInputText = text;

    let postCitation = '';
    const regexCitation =
      /\([a-zA-Z0-9,.\[\]\"\;\-\-\:\& ]*[0-9]*[a-zA-Z0-9,.\[\]\"\;\-\–\:\& ]*\)[.,]*$/; //Regex or other Citation cases
    const regexWikiPediaCitation = /\.[\[[a-zA-Z0-9]+\]]*$/; //Regex for wikipedia cases

    /* If text matches with citation then store the text into the postCitation variable 
        and trim the citation from the main text */
    if (regexCitation.test(paraphraseInputText.trim())) {
      postCitation = regexCitation.exec(paraphraseInputText.trim());
      postCitation = postCitation[0];
      if (paraphraseInputText.trim().replace(regexCitation, '').trim().length != 0)
        paraphraseInputText = paraphraseInputText.trim().replace(regexCitation, '');
      else postCitation = '';
    } else if (regexWikiPediaCitation.test(paraphraseInputText.trim())) {
      postCitation = regexWikiPediaCitation.exec(paraphraseInputText.trim());
      postCitation = postCitation[0];
      paraphraseInputText = paraphraseInputText.trim().replace(regexWikiPediaCitation, '');
    }

    let newLineRegex = /[ ]*[\r\n]+[ ]*/; //Regex for space with new line at the end of sentences
    if (newLineRegex.test(paraphraseInputText)) {
      if (paraphraseInputText.replace(newLineRegex, '').trim().length != 0)
        paraphraseInputText = paraphraseInputText.trim().replace(newLineRegex, ' ');
    }

    text = paraphraseInputText;
    options.text = text;

    //language variable in single para call
    options.inputLang = ParaModel.inputLanguage;

    if (postCitation.length > 0) postCitation += ' ';
    this.postCitation = postCitation;

    if (this.quoteIndex === null || this.quoteIndex === undefined) this.quoteIndex = -1;

    options.quoteIndex = this.quoteIndex;
    return new Promise((resolvepromise, rejectPromise) => {
      getParaphrase(options, options['strength'])
        .then(paraphraserResponse => {
          this.singleParaCallStatus = true;
          const freezeWords = getReduxStore()?.getState()?.pphr?.freezeWords;
          const containedFrozenWords = [];
          freezeWords.forEach(frozenWord => {
            if (
              paraphraserResponse &&
              paraphraserResponse[0].sent.match(
                new RegExp(`(^| )${frozenWord}($|[,?!. ]*[ ]+|[,?!.]$)`, 'i')
              )
            ) {
              containedFrozenWords.push(frozenWord);
            }
          });
          if (containedFrozenWords.length) {
            let hasTimedOut = false;
            return new Promise((resolve, reject) => {
              const timeout = setTimeout(() => {
                hasTimedOut = true;
                reject({ error: '30 seconds timed out!' });
              }, 30000);

              postFreezeWords({
                keep: containedFrozenWords,
                data: paraphraserResponse,
              })
                .then(res => {
                  clearTimeout(timeout);
                  if (!hasTimedOut) {
                    resolve(res);
                  }
                })
                .catch(err => {
                  clearTimeout(timeout);
                  if (!hasTimedOut) reject(err);
                });
            })
              .then(freezerResponse => {
                const parakeys = [
                  'paras_1',
                  'paras_2',
                  'paras_3',
                  'paras_4',
                  'paras_5',
                  'paras_7',
                  'paras_8',
                  'paras_9',
                  'paras_10',
                ];

                let isValidArrayResponeFromFreezer = true;
                for (let key of parakeys) {
                  if (freezerResponse[0][key] && freezerResponse[0][key].length === 0) {
                    isValidArrayResponeFromFreezer = false;
                    break;
                  }
                }
                if (isValidArrayResponeFromFreezer) {
                  this.actionAfterParaphrase(freezerResponse, text, cb);
                } else {
                  this.actionAfterParaphrase(paraphraserResponse, text, cb);
                  Track.freezerSentEmptyArrayResponse({
                    keep: containedFrozenWords,
                    data: paraphraserResponse,
                  });
                }
                this.frozenWords = containedFrozenWords;
              })
              .catch(err => {
                this.actionAfterParaphrase(paraphraserResponse, text, cb);
                Bugsnag.notify({ name: 'FreezerApiError', message: JSON.stringify(err) });
              });
          } else {
            this.actionAfterParaphrase(paraphraserResponse, text, cb);
            this.frozenWords = containedFrozenWords;
          }
        })
        .then(data => {
          resolvepromise('true');
        })
        .catch(error => {
          rejectPromise('false');
        });
    });
  };

  resetParaphraser = () => {
    this.clearBeams();
    let obj = this.outputs[0];
    this.outputs = [];
    this.outputs.push(obj);
    this.focusedOutput = this.outputs[0];
  };
}

export default Paraphraser;
